//<reference path="../views/partials/announcementlisting/listing-loader.js" />
// This file is where we will gather all Vue "loader" modules
// each controlling the initialization of an app, and call their load() function (aliased to avoid name conflicts) within the loadComponents() function.
import { load as loadHome } from "../Views/home-loader.js"; // app instance
import { load as PhotoGallery } from "../Views/Partials/MediaCenter/PhotoGallery/PhotoGallery-Loader.js";
import { load as SharedGenericListing } from "../Views/Partials/MediaCenter/SharedComponents/SharedGenericListing/SharedGenericListing-Loader.js";
import { load as SharedGenericLatestDetails } from "../Views/Partials/MediaCenter/SharedComponents/SharedGenericLatestDetails/SharedGenericLatestDetails-Loader.js";
import { load as SharedGenericGalleryListing } from "../Views/Partials/MediaCenter/SharedComponents/SharedGenericGalleryListing/SharedGenericGalleryListing-Loader.js";
import { load as SocialMediaSharing } from "../Views/Partials/SocialMediaSharing/SocialMediaSharing-Loader.js";
import { load as SharedGallerySlider } from "../Views/Partials/MediaCenter/SharedComponents/SharedGallerySlider/SharedGallerySlider-Loader.js";
import { load as NewsLetterSubscription } from "../Views/Partials/HomePage/NewsLetterSubscription/NewsLetterSubscription-Loader.js";
import { load as Announcements } from "../Views/Partials/HomePage/Announcements/Announcements-Loader.js";
import { load as Services } from "../Views/Partials/HomePage/Services/Services-Loader.js";
import { load as Register } from "../Views/Partials/Register/Register-Loader.js";
import { load as Login } from "../Views/Partials/Login/Login-Loader.js";
import { load as OTP } from "../Views/Partials/Otp/OTP-Loader.js";
import { load as Email } from "../Views/Partials/Email/Email-Loader.js";
import { load as NewPassword } from "../Views/Partials/NewPassword/NewPassword-Loader.js";
import { load as UserProfile } from "../Views/Partials/UserProfile/UserProfile-Loader.js";
import { load as ServiceListing } from "../Views/Partials/ServiceListing/ServiceListing-loader.js";
import { load as PaymentHistory } from "../Views/Partials/PaymentHistory/PaymentHistory-loader.js";
import { load as FunctionList } from "../Views/Partials/FunctionList/FunctionList-loader.js";
import { load as ListingCarousel } from "../Views/Partials/AnnouncementListing/ListingCarousel-Loader.js";
import { load as Regulations } from "../Views/Partials/Regulations/Regulations-loader.js";
import { load as GenericServiceListing } from "../Views/Partials/GenericPageComponent/ServiceListing/ServiceListing-loader.js";
import { load as AnnouncementListingService } from "../Views/Partials/AnnouncementListingService/AnnouncementListingService-loader.js";
import { load as SectorList } from "../Views/Partials/SectorList/SectorList-loader.js";
import { load as SectorDetails } from "../Views/Partials/SectorDetails/SectorDetails-loader.js";
import { load as ServiceCardLoader } from "../Views/Partials/GenericListingComponent/ServicesBlock/ServiceCard-loader.js";
import { load as AnnouncementCardLoader } from "../Views/Partials/GenericListingComponent/AnnouncementBlock/AnnouncementCard-loader.js";
import { load as RulesAndRegulationsLoader } from "../Views/Partials/GenericListingComponent/RulesAndRegulationsBlock/RulesAndRegulations-loader.js";
import { load as RoadMapLoader } from "../Views/Partials/GenericListingComponent/RoadMap/RoadMap-loader.js";
import { load as DepartmentDetailsLoader } from "../Views/Partials/DepartmentDetails/DepartmentDetails-loader.js";
import { load as SurveysListingLoader } from "../Views/Partials/SurveysListing/SurveysListing-loader.js";
import { load as TrainingList } from "../Views/Partials/TrainingList/TrainingList-loader.js";
import { load as SearchResult } from "../Views/Partials/SearchResultPage/SearchResult-loader.js";
import { load as BoardMembers } from "../Views/Partials/BoardMembers/BoardMembers-loader.js"
import { load as Vision } from "../Views/Partials/Vision/VisionLoader.js";
import { load as OrgChart } from "../Views/Partials/OrgChart/OrgChart-loader.js";



export function loadComponents() {
  // run load function that exported from the home-loader.js we created before
  loadHome();
  PhotoGallery();
  SharedGenericListing();
  SharedGenericLatestDetails();
  SharedGenericGalleryListing();
  SocialMediaSharing();
  SharedGallerySlider();
  NewsLetterSubscription();
  Announcements();
  Services();
  Register();
  Login();
  OTP();
  Email();
  NewPassword();
  UserProfile();
  ServiceListing();
  PaymentHistory();
  FunctionList();
  ListingCarousel();
  Regulations();
  GenericServiceListing();
  AnnouncementListingService();
  SectorList();
  SectorDetails();
  ServiceCardLoader();
  AnnouncementCardLoader();
  RulesAndRegulationsLoader();
  RoadMapLoader();
  DepartmentDetailsLoader();
  SurveysListingLoader();
  TrainingList();
  SearchResult();
  BoardMembers();
  Vision();
  OrgChart();
}
